<template>
  <div class="container">
    <div class="top-box">
      <img src="../../../static/images/index/bg2.png" />
      <div>信息填写</div>
    </div>
    <div class="formBox">
      <div class="itemBox">
        <div class="leftBox">
          <span>*</span>
          <span>展位号</span>
        </div>
        <input
          v-model="keyword"
          placeholder="展馆号-展台号"
          @input="updateValue"
          @focus="focusValue"
          @blur="blurValue"
        />
      </div>
      <div class="tips" v-show="showTips0">
        *请在展位号栏目选择对应的展位号，格式为“展馆号-展台号”
      </div>
      <div class="selectBox" v-if="showNum">
        <div
          v-for="(item, index) in listNum"
          :key="index"
          @click.stop="selectHandle(item)"
        >
          {{ item.HallText }}
        </div>
      </div>

      <div class="itemTwoBox">
        <div class="twoBox">
          <div class="leftBox">
            <span>*</span>
            <span>展区</span>
          </div>
          <input placeholder="展区号" v-model="info.Region" readonly />
        </div>
        <div class="twoBox">
          <div class="leftBox">
            <span>*</span>
            <span>展馆</span>
          </div>
          <input placeholder="展馆号" v-model="info.HallNo" readonly />
        </div>
      </div>
      <div class="itemBox">
        <div class="leftBox">
          <span>*</span>
          <span>参展企业</span>
        </div>
        <input placeholder="企业名称" v-model="info.CompanyNameChi" readonly />
      </div>
      <div class="itemBox">
        <div class="leftBox">
          <span>*</span>
          <span>车牌号</span>
        </div>
        <input
          placeholder="请输入您的车牌号"
          v-model="carNum"
          @focus="focusCarNum"
          @blur="blurCarNum"
          @input="inputCarNum"
        />
        <img
          v-if="inputShow4"
          src="../../../static/images/index/icon_err.png"
          style="width: 16px; height: 16px"
          @click="clearCarNum"
        />
        <img
          v-if="rightShow4"
          src="../../../static/images/index/icon_right.png"
          style="width: 16px; height: 16px"
        />
      </div>
      <div class="tips" v-show="showTips4">
        *请填写正确的车牌号格式，例如：粤AZ7735
      </div>
      <div class="itemBox">
        <div class="leftBox">
          <span>*</span>
          <span>货车类型</span>
        </div>
        <input
          placeholder="请选择"
          readonly
          v-model="carType"
          @click="show = true"
        />
        <span class="iconfont icon-arrow-down"></span>
      </div>
      <div class="itemBox">
        <div class="leftBox">
          <span>*</span>
          <span>司机姓名</span>
        </div>
        <input placeholder="请填写司机真实姓名" v-model="driverName" />
      </div>
      <div class="itemBox">
        <div class="leftBox">
          <span>*</span>
          <span>身份证</span>
        </div>
        <input
          placeholder="请输入司机身份证号"
          v-model="idCard"
          @focus="focusIdcard"
          @blur="blurIdCard"
        />
        <img
          v-if="inputShow1"
          src="../../../static/images/index/icon_err.png"
          style="width: 16px; height: 16px"
          @click="clearCard"
        />
        <img
          v-if="rightShow1"
          src="../../../static/images/index/icon_right.png"
          style="width: 16px; height: 16px"
        />
      </div>
      <div class="tips" v-show="showTips1">
        *请填写正确的身份证号，以便核验身份
      </div>
      <div class="itemBox">
        <div class="leftBox">
          <span>*</span>
          <span>申请种类</span>
        </div>
        <van-radio-group
          style="margin-left: 15px; width: 300px"
          v-model="radio"
          direction="horizontal"
          @change="changeCarType"
        >
          <van-radio name="1" icon-size="12px" checked-color="#C00B0B"
            >筹展展品货车证</van-radio
          >
          <van-radio name="2" icon-size="12px" checked-color="#C00B0B"
            >撤展展品货车证</van-radio
          >
        </van-radio-group>
      </div>
      <div class="itemBox">
        <div class="leftBox">
          <span>*</span>
          <span>进馆时间</span>
        </div>
        <input
          v-model="placeTime"
          placeholder="请选择时间"
          readonly
          @click="showTime = true"
        />
        <span class="iconfont icon-arrow-down"></span>
      </div>
      <div class="itemBox">
        <div class="leftBox">
          <span>*</span>
          <span>手机号</span>
        </div>
        <input placeholder="请输入手机号" v-model="mobile" />
      </div>
      <div class="itemBox">
        <div class="leftBox">
          <span>*</span>
          <span>验证码</span>
        </div>
        <input
          style="width: 175px"
          type="number"
          placeholder="请输入验证码"
          v-model="code"
        />
        <button
          class="forgetButton"
          @click.stop="getVerificationCode"
          :disabled="disabled"
          :style="btnStyle"
        >
          {{ codename }}
        </button>
      </div>
      <div class="checkBox">
        <input id="item1" type="radio" name="item" value="item1" checked />
        <label for="item1"></label>
        <span>我已认真阅读并同意《隐私条款》</span>
      </div>
      <div class="nextBtn" @click="submitHandle">提交信息</div>
    </div>

    <!-- 货车类型 -->
    <van-popup v-model="show" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="carConfirm"
        @cancel="show = false"
      />
    </van-popup>

    <!-- 时间选择 -->
    <van-popup v-model="showTime" position="bottom">
      <van-datetime-picker
        type="date"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="showTime = false"
        @confirm="timeConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import { sendSMS } from "@/api/login";
import { getShareData } from "@/utils/share";
import { formatTimeDay } from "@/utils/date.js";
import { getExhibitionHallRecords, addExhibitionCarRecord } from "@/api/index";
import { RadioGroup, Radio, DatetimePicker, Popup, Picker, Toast } from "vant";
export default {
  name: "drivingLicense",
  components: {
    "van-radio-group": RadioGroup,
    "van-radio": Radio,
    "van-picker": Picker,
    "van-datetime-picker": DatetimePicker,
    "van-popup": Popup,
    Toast,
  },
  data() {
    return {
      showTips0: false, //展位号提示

      showTips4: false, //车牌号
      rightShow4: false,
      inputShow4: false,

      showTips1: false, //身份证
      rightShow1: false,
      inputShow1: false,

      showTips2: false, //手机号
      rightShow2: false,
      inputShow2: false,

      showTips3: false, // 验证码提示

      showNum: false, //展位号
      show: false, //货车类型
      showTime: false, //进馆时间

      checked: true, //隐私条款

      info: "",
      keyword: "", // 展位号
      listNum: [], //展位号列表

      radio: 1, //车辆类型
      carNum: "", //车牌号
      carType: "", //货车类型
      driverName: "", //司机名字
      idCard: "", //身份证
      placeTime: "", //进馆时间
      columns: ["厢式货车", "平板货车", "拖挂货车"], //货车类型
      minDate: new Date(2021, 0, 1),
      maxDate: new Date(2021, 10, 1),
      mobile: "",
      code: "",
      codename: "获取验证码",
      time: null,
      timer: 60,
      disabled: false,
      btnStyle: "",
    };
  },
  methods: {
    //选择货车
    carConfirm(value) {
      this.carType = value;
      this.show = false;
    },

    //时间选择
    timeConfirm(value) {
      this.placeTime = formatTimeDay(value);
      this.showTime = false;
    },

    //改变申请种类
    changeCarType(name) {
      if (name == 1) {
        this.placeTime = "2021-07-31";
        this.minDate = new Date(2021, 6, 31);
        this.maxDate = new Date(2021, 7, 2);
      } else {
        this.placeTime = "2021-08-06";
        this.minDate = new Date(2021, 7, 6);
        this.maxDate = new Date(2021, 7, 6);
      }
    },

    //获得焦点
    focusValue() {
      this.showNum = true;
      getExhibitionHallRecords({ Keyword: "" }).then((res) => {
        this.listNum = res.Data;
      });
    },

    //失去焦点
    blurValue() {
      setTimeout((res) => {
        this.listNum.forEach((element) => {
          if (this.keyword.toUpperCase() === element.HallText.toUpperCase()) {
            this.selectHandle(element);
          }
        });
      }, 100);
    },

    //获得焦点
    focusIdcard() {
      this.cardHandle();
    },

    //失去焦点
    blurIdCard() {
      this.cardHandle();
    },

    //清除
    clearCard() {
      this.idCard = "";
    },

    //车牌号改变
    inputCarNum() {
      this.carNum = this.carNum.toUpperCase();
    },
    //获取焦点车牌号
    focusCarNum() {
      this.carNumHandle();
    },

    blurCarNum() {
      this.carNumHandle();
    },

    //清除电话
    clearCarNum() {
      this.carNum = "";
    },

    //车牌号验证
    carNumHandle() {
      if (this.isVehicleNumber(this.carNum) == false) {
        this.inputShow4 = true;
        this.showTips4 = true;
        this.rightShow4 = false;
      } else {
        this.showTips4 = false;
        this.inputShow4 = false;
        this.rightShow4 = true;
      }
    },

    //车牌号验证方法
    isVehicleNumber(vehicleNumber) {
      var xreg =
        /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF]$)|([DF][A-HJ-NP-Z0-9][0-9]{4}$))/;
      var creg =
        /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1}$/;
      if (vehicleNumber.length == 7) {
        return creg.test(vehicleNumber);
      } else if (vehicleNumber.length == 8) {
        return xreg.test(vehicleNumber);
      } else {
        return false;
      }
    },

    //身份证号验证
    cardHandle() {
      if (this.idCard == "" || this.IdentityCodeValid(this.idCard) == false) {
        this.inputShow1 = true;
        this.showTips1 = true;
        this.rightShow1 = false;
      } else {
        this.showTips1 = false;
        this.inputShow1 = false;
        this.rightShow1 = true;
      }
    },

    //身份证号合法性验证
    //支持15位和18位身份证号
    //支持地址编码、出生日期、校验位验证
    IdentityCodeValid(code) {
      var city = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江 ",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北 ",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏 ",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外 ",
      };
      // var tip = "";
      var pass = true;
      if (!code || !/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(code)) {
        // tip = "身份证号格式错误";
        pass = false;
      } else if (!city[code.substr(0, 2)]) {
        // tip = "地址编码错误";
        pass = false;
      } else {
        //18位身份证需要验证最后一位校验位
        if (code.length == 18) {
          code = code.split("");
          //∑(ai×Wi)(mod 11)
          //加权因
          var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
          //校验位
          var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
          var sum = 0;
          var ai = 0;
          var wi = 0;
          for (var i = 0; i < 17; i++) {
            ai = code[i];
            wi = factor[i];
            sum += ai * wi;
          }
          var last = parity[sum % 11];
          if (last != code[17]) {
            // tip = "校验位错误";
            pass = false;
          }
        }
      }
      return pass;
    },

    //数据变化
    updateValue() {
      getExhibitionHallRecords({ Keyword: this.keyword }).then((res) => {
        this.listNum = res.Data;
      });
    },

    //选择展位
    selectHandle(item) {
      this.info = item;
      this.keyword = item.HallText;
      this.showNum = false;
    },

    //点击获取验证码
    getVerificationCode() {
      var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (this.mobile == "" || myreg.test(this.mobile) === false) {
        Toast("请填写正确的手机号");
        return false;
      }
      this.disabled = true;
      var data = {
        Mobile: this.mobile,
        Type: 7,
      };

      sendSMS(data).then((res) => {
        this.time = setInterval(() => {
          this.getSecond(60);
        }, 1000);
      });
    },

    //获取倒计时
    getSecond(timer) {
      this.btnStyle = { backgroundColor: "#999" };
      this.codename = this.timer + "s后重试";
      this.timer--;
      if (this.timer > 0) {
        this.codename = this.timer + "s后重试";
      } else {
        clearInterval(this.time);
        this.disabled = false;
        this.codename = "获取验证码";
        this.btnStyle = { backgroundColor: "#eb4e4e" };
        this.timer = 60;
      }
    },

    //提交信息
    submitHandle() {
      var that = this;
      if (that.keyword == "") {
        that.showTips0 = true;
        Toast("请选择展位号");
        return false;
      }
      if (that.carNum == "") {
        that.showTips4 = true;
        Toast("请填写车牌号");
        return false;
      }
      if (that.idCard == "") {
        that.showTips1 = true;
        Toast("请填写身份证号");
        return false;
      }
      if (that.mobile == "") {
        that.showTips2 = true;
        Toast("手机号不能为空！");
        return false;
      }
      if (that.code == "") {
        that.showTips3 = true;
        Toast("验证码不能为空！");
        return false;
      }
      addExhibitionCarRecord({
        HallNo: that.info.HallNo,
        PlaceNo: that.info.PlaceNo,
        CompanyNameChi: that.info.CompanyNameChi,
        ApplyId: that.info.ApplyId,
        Mobile: that.mobile,
        Code: that.code,
        CarNum: that.carNum,
        CarType: that.carType,
        DriverName: that.driverName,
        IdCard: that.idCard,
        ApplyType: that.radio == 1 ? "筹展展品货车证" : "撤展展品货车证",
        ApplyDate: that.placeTime,
      }).then((res) => {
        that.Common.showMsg("提交成功", function () {
          that.$router.push({
            path: "/viewOrder",
            query: { mobile: that.mobile },
          });
        });
      });
    },
  },
  mounted() {
    getShareData(
      window.location.href,
      "申请展品筹撤展车证（2022光亚展）",
      "2022广州国际照明展览会+广州国际建筑电气技术及智能家居展览会申请车证通道",
      "https://files.alighting.com/Cover/car20210727.jpg"
    );
  },
};
</script>
<style lang="less" scoped >
.top-box {
  width: 375px;
  height: 104px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
  }
  div {
    position: absolute;
    z-index: 1;
    bottom: 40px;
    left: 50%;
    transform: translate(-50%, 0);
    color: #fff;
    font-size: 23px;
    font-weight: bold;
  }
}
.formBox {
  margin: 10px;
  padding-bottom: 30px;
  position: relative;
  .tips {
    color: #eb4e4e;
    font-size: 11px;
    margin-top: 10px;
  }
  .selectBox {
    width: 100%;
    height: 125px;
    border: 1px solid #ddd;
    position: absolute;
    top: 35px;
    left: 0px;
    z-index: 2;
    border-radius: 0px 0px 5px 5px;
    text-align: center;
    overflow-y: auto;
    background-color: #fff;
    box-sizing: border-box;
    div {
      color: #666;
      font-size: 16px;
      height: 40px;
      line-height: 40px;
    }
  }
  .itemBox {
    font-size: 14px;
    display: flex;
    align-items: center;
    flex-direction: row;
    border: 1px solid #ddd;
    height: 45px;
    line-height: 45px;
    margin-top: 10px;
    border-radius: 5px;
    .leftBox {
      width: 80px;
      text-align: right;
      span {
        &:first-child {
          color: #c00b0b;
          margin-right: 5px;
        }
      }
    }
    input {
      height: 35px;
      line-height: 35px;
      width: 220px;
      border: none;
      margin-left: 15px;
    }
    .forgetButton {
      font-size: 12px;
      width: 90px;
      height: 32px;
      line-height: 32px;
      box-sizing: border-box;
      background-color: #eb4e4e;
      border: none;
      color: #fff;
      border-radius: 4px;
      margin-right: 5px;
    }
    .iconfont {
      color: #666;
      font-size: 14px;
      margin-right: 10px;
    }
  }
  .itemTwoBox {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    margin-top: 10px;
    .twoBox {
      display: flex;
      align-items: center;
      flex-direction: row;
      border: 1px solid #ddd;
      height: 45px;
      line-height: 45px;
      border-radius: 5px;
      &:first-child {
        margin-right: 12px;
      }
      .leftBox {
        width: 70px;
        text-align: right;
        span {
          &:first-child {
            color: #c00b0b;
            margin-right: 5px;
          }
        }
      }
      input {
        height: 35px;
        line-height: 35px;
        width: 72px;
        border: none;
        margin-left: 15px;
      }
    }
  }
  .checkBox {
    font-size: 13px;
    color: #eb4e4e;
    text-align: center;
    margin-top: 25px;
    margin-bottom: 27px;
    position: relative;
    input[type="radio"] {
      width: 16px;
      height: 16px;
      opacity: 0;
    }

    label {
      position: absolute;
      left: 65px;
      top: 4px;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      border: 1px solid #999;
    }

    /*设置选中的input的样式*/
    /* + 是兄弟选择器,获取选中后的label元素*/
    input:checked + label {
      background-color: #eb4e4e;
      border: 1px solid #eb4e4e;
    }

    input:checked + label::after {
      position: absolute;
      content: "";
      width: 4px;
      height: 8px;
      top: 2px;
      left: 5px;
      border: 2px solid #fff;
      border-top: none;
      border-left: none;
      transform: rotate(45deg);
    }
  }
  /deep/ .van-radio-group {
    display: flex;
  }
  .nextBtn {
    font-size: 18px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    color: #ffff;
    background-color: #eb4e4e;
    border-radius: 22px;
  }
}
</style>